<template>
   <loading :active.sync="loading" 
            :can-cancel="false" 
            :is-full-page="false">Sign In Silent</loading>
</template>

<script>
//import this.HTTP from "../Http";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.min.css";
import * as Oidc from "oidc-client";

export default {
  name: "silent-view",
  components: { Loading },
  data: function() {
    return {
      loading: true
    };
  },
  mounted() {
    this.HTTP.signinSilentCallback().then(() => {
      this.HTTP.setHeader().then(() => {
        console.log("header settled");
      });
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/Silent.Vue